module.exports = __webpack_public_path__ + "fonts/Inter-200-greek-ext10.318d4ba.woff2";